import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Box, Button, HStack, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { hideModal } from '../../../redux/modules/modal';
import colors from '../../../styles/theme/foundation/colors';
import CertificateCreationBlueprintType from '../../../types/CertificateCreationBlueprintType';

const TotalDocumentSizeExceededModal = ({ blueprint, totalDocSize }) => {
  const dispatch = useDispatch();
  const mb = useMemo(() => Math.round((totalDocSize / 1024 / 1024) * 100) / 100, [totalDocSize]);

  return (
    <Box color={colors.greyScale['800']}>
      <Text mb={4} textStyle="bodyXl500">
        Your total document size exceeds the limits for AI document scanning
        <span style={{ color: colors.primaryScale['600'] }}> (100 MB)</span>
        .
      </Text>
      <Text mb={4} textStyle="bodyXl500">
        Current total document size:
        <span style={{ color: colors.error.primary['600'] }}>{` ${mb} MB`}</span>
        .
      </Text>

      <Text>You can still continue, but PINS won’t be able to scan your documents or extract policy details automatically.</Text>
      <Text>To proceed with AI scanning, reduce the total file size. Otherwise, continue with a manual document review.</Text>

      <HStack justifyContent="center" mt={6} spacing={4}>
        <Button
          variant="secondary"
          onClick={() => {
            dispatch(hideModal());
          }}
        >
          Cancel
        </Button>

        <Button
          onClick={() => {
            dispatch(hideModal());
            dispatch(blueprint.nextStep());
          }}
        >
          Continue with Manual Review
        </Button>
      </HStack>

    </Box>
  );
};

TotalDocumentSizeExceededModal.propTypes = {
  blueprint: CertificateCreationBlueprintType,
  totalDocSize: PropTypes.number.isRequired
};

export default TotalDocumentSizeExceededModal;
